import React, { useCallback, useEffect, useState } from 'react'
import RadioButton from 'src/components/Actions/radioButton';
import CheckBox from 'src/components/Form/checkbox';

export default function Seller({list = [], level, selectedItems = [], updateSelectedItems, isRadio = false}) {
  const rawKeywords = selectedItems?.find((item) => item.level == level)?.keywords || [];
  const keywordsForRadio = isRadio && rawKeywords.length > 1 ? [rawKeywords[0]] : rawKeywords;
  const [selectedList, setSelectedList] = useState(keywordsForRadio);
  useEffect(() => {
      const next = selectedItems?.find((item) => item.level == level)?.keywords || [];
      setSelectedList(isRadio && next.length > 1 ? [next[0]] : next);
  }, [selectedItems, isRadio])

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
        const allSellerValues = list.map(seller => seller.value);
        setSelectedList(allSellerValues);
        const updatedSelectedItems = [...selectedItems];
        const levelIndex = updatedSelectedItems.findIndex(item => item.level === level);
        if (levelIndex !== -1) {
            updatedSelectedItems[levelIndex].keywords = allSellerValues;
        } else {
            updatedSelectedItems.push({ level: level, keywords: allSellerValues });
        }
        updateSelectedItems(updatedSelectedItems);
    } else {
        setSelectedList([]);
        const updatedSelectedItems = [...selectedItems];
        const levelIndex = updatedSelectedItems.findIndex(item => item.level === level);
        if (levelIndex !== -1) {
            updatedSelectedItems[levelIndex].keywords = [];
            updateSelectedItems(updatedSelectedItems);
        }
    }
};

  const handleIndividualSelect = useCallback((event, seller) => {
    console.log("handleIndividualSelect", { event, level, seller, isRadio });
    updateSelectedItems(event, level, seller, isRadio);
  }, [level, isRadio, updateSelectedItems]);

  const SelectBox = isRadio ? RadioButton : CheckBox

  return (
    <React.Fragment>
            {/* <h2 className='f-12 f-w-500 mb-2 f-101828'>Seller </h2> */}
            {!isRadio && list?.length > 1 ? <div className='mt-3' style={{paddingLeft: '2px'}}>
              <CheckBox id="select_all_seller" label="Select All" classes={`f-12 f-w-500 f-101828 ${selectedList.length > 0 && selectedList.length !== list.length ? 'indet_check' : ''}`}
                        checked={selectedList.length === list.length || selectedList.length > 0} action={handleSelectAll} />
            </div> : null}

            <ul className='global-filter-tabs-list-items'>
                {list?.map((seller, index) => {
                  return (
                    <li key={seller?.value} className='d-flex align-items-center'> 
                    <div className='d-flex align-items-center gap-10'>
                        <SelectBox
                          id={seller?.value}
                          radioname={isRadio ? 'select-seller-id' : seller.value}
                          classes=""
                          value={seller.value}
                          checked={selectedList?.indexOf(seller.value) > -1}
                          action={(event) => handleIndividualSelect(event, seller)}
                        />
                        <div className='d-flex flex-column'>
                          <h2 className='f-12 f-w-500 d-flex align-items-center gap-4 f-101828'>
                            {seller.label}
                            {/* <span className='f-0A60CB'>({seller.profile})</span> */}
                          </h2>
                          <span className='f-12 f-w-500 f-10182880 l-20'>{seller.value}</span>
                        </div>
                    </div>
                </li>
                  )
                })}
                {list?.length == 0 ? <li className="text-dark f-10 f-w-500 hei-70 d-flex align-items-center justify-content-center no-wrap">No Seller Account found</li> : null}
            </ul>
        </React.Fragment>
  )
}
